const direct_to_garment = [
    {
        stepNumber: 2,
        stepName: "Garment Options",
    },
    {
        stepNumber: 3,
        stepName: "Print Location",
    },
    {
        stepNumber: 4,
        stepName: "Garment Quantity",
    },
];

const dye_sublimation = [
    {
        stepNumber: 2,
        stepName: "Garment Options",
    },
    {
        stepNumber: 3,
        stepName: "Garment Quantity",
    },
];

const embroidery = [
    {
        stepNumber: 2,
        stepName: "Garment Options",
    },
    {
        stepNumber: 3,
        stepName: "Garment Quantity",
    },
];

const other = [
    {
        stepNumber: 2,
        stepName: "Request Details",
    },
]

export const STEPS = {
    direct_to_garment,
    dye_sublimation,
    embroidery,
    other,
};

